exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".itinerary-details-modal .zb-modal-content{width:780px}@media(min-width:601px)and (max-width:1200px){.itinerary-details-modal .zb-modal-content{max-width:100%;width:auto;margin-left:40px;margin-right:40px}}", ""]);

// exports
